import React, { useState } from "react";
import "../../page_content.css";

const Library = () => {
  return (
    <div>
      <h1 className="title">Library</h1>
      <hr />
      <div className="page-content-gallery">
        <img
          src="/assets/images/Library/lib_1.webp"
          alt="Award 1"
          className="award-img"
        />
        <img
          src="/assets/images/Library/lib_2.webp"
          alt="Award 2"
          className="award-img"
        />
      </div>
      <p>
        MANET Pune Library serves as a resource center under the norms of ISO
        9001-2015 and aims to develop a comprehensive collection useful for
        faculty members and cadets of the institute, ensuring efficient
        dissemination of information.
      </p>

      <div>
        <div>
          <h2 className="innerpage-heading ">B. Tech. Marine Engineering</h2>
          <p>
            B. Tech. section has 8504 books which are organized as per the
            'Dewey Decimal Classification Scheme'. Reference books among those
            are 1079 in number, holding various Marine Engineering Codes, OCIMF
            Publications, Institute of Marine Engineers Publications, IMO
            Publication latest editions, Manuals, Important Titles like Reed's
            series and other allied subjects as well as fiction and non-fiction
            titles.
          </p>
          <p>
            The MANET Pune library also has a CD collection comprising of MAN
            and B&W, KARCO Series, Safety at Sea, Ship Safety Movies, etc.
            Besides this, the library also subscribes to around 18 periodicals -
            07 technical and 11 non- technical, the majority including MAREX
            Bulletin, IMO News, Motorship, Bhandarkar Shipping News, Marine
            Engineering Review Journal, etc.
          </p>
        </div>

        <div>
          <h2 className="innerpage-heading ">Library Service</h2>
          <p>
            Library Services like catalogue search, book reservation, issue/
            return, also all other activities are done with the help of
            Enterprise Resource Planning (ERP- Cloud computing application of
            TCS). The MANET Pune library also provides various other services to
            its cadets like CAS, SDI, document delivery and newspaper clipping,
            and on-demand online searching services. Daily Newspaper Service is
            rendered through daily newspapers, to all users. The MANET Library
            also has a facility of a reading room with a seating capacity of
            around 110.
          </p>
        </div>

        <div>
          <h2 className="innerpage-heading ">Library Rules & Regulations</h2>
          <ul className="page-content-lists">
            <li>
              The library will issue 2 books to a cadet for 7 days and will be
              reissued depending upon its demand.
            </li>
            <li>
              A fine of Rs. 5/- will be imposed per day per book on any cadet
              returning an overdue book.
            </li>
            <li>
              The borrower will be held responsible for materials out on loan if
              the material is lost, an immediate report should be made to the
              LIBRARIAN. A borrower is allowed to either replace the book lost
              or damaged by purchasing the latest edition himself.
            </li>
            <li>
              The library has a separate reference section; in which books are
              strictly to be used against l-cards.
            </li>
          </ul>
        </div>

        <div>
          <h2 className="innerpage-heading ">Library working hours</h2>
          <p>
            Library is kept open on all working days Monday to Friday - 09:00
            Hrs. to 19:00 Hrs. Saturday and Sunday off.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Library;
